import { GamesProvider } from "../Context/GamesContext"
import Games from "./Games"


const GamesContainer = () => {
    return(
        <GamesProvider>
            <Games/>
        </GamesProvider>
    )
}

export default GamesContainer
